import _ from 'lodash';
import Logger from 'logger';
import { API_V1 } from './APIs/APIv1';

export const getFrontendVersion = async (signal?: AbortSignal) => {
  try {
    const response = await API_V1.get('/misc/frontend-version', {
      signal,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error fetching frontend version!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
